/* eslint-disable @typescript-eslint/no-unsafe-call */
import { yupResolver } from '@hookform/resolvers/yup';
import Cookies from 'js-cookie';
import { FormEventHandler, useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postHssauth, postLogin } from '../../../api/auth/auth';
import { PostHssauthBody, PostLoginBody } from '../../../api/model';
import { COOKIE_EXPIRES_FOR_API_KEY, COOKIE_NAME_FOR_API_KEY } from '../../../constants/api';
import { getAxiosRequestConfig } from '../../../utils/api';
import yup from '../../../utils/custom-yup';
import * as SessionStorageUtils from '../../../utils/sessionStorage';
import SpinnerModal from '../../modules/SpinnerModal';

function LoginTestPage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const schema = yup.object({
    user_id: yup.string().trim().required('Please enter your user ID.'),
    password: yup.string().trim().required('Please enter a password.'),
  });
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<{ user_id: string; password: string }>({
    resolver: yupResolver(schema),
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorCode] = useState<number>();
  const [params] = useSearchParams();
  const isLogout = () => params?.get('logout') === '1' || false;

  // ダブりログイン用なので、コメントアウト
  // データが変更されたときの動作
  useEffect(() => {
    const checkAuth = async () => {
      const axiosRequestConfig = getAxiosRequestConfig(language);
      const postHssauthBody: PostHssauthBody = {
        user_id_text: '' as string | undefined,
      };

      await postHssauth(postHssauthBody, axiosRequestConfig)
        .then((postHssauthResponse) => {
          if (postHssauthResponse.status === 200) {
            if (postHssauthResponse.data.api_key != null) {
              Cookies.set(COOKIE_NAME_FOR_API_KEY, postHssauthResponse.data.api_key, {
                expires: COOKIE_EXPIRES_FOR_API_KEY,
              });
              SessionStorageUtils.clear();
              localStorage.removeItem('PsDetails.PsTextCondition.Copy');
              navigate('../home');
            }
          }
        })
        .catch(() => {
          setError('user_id', { type: 'custom', message: `The User ID or password is incorrect.` });
        });
    };
    if (params?.get('logout') !== '1') {
      void checkAuth();
    }
  }, [language, navigate, setError, params]);

  const onSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    void handleSubmit(async (data: FieldValues) => {
      setIsSubmitting(true);
      const axiosRequestConfig = getAxiosRequestConfig(language);
      const postLoginBody: PostLoginBody = {
        user_id_text: data.user_id as string | undefined,
        password: data.password as string | undefined,
      };

      await postLogin(postLoginBody, axiosRequestConfig)
        .then((postLoginResponse) => {
          if (postLoginResponse.status === 200) {
            if (postLoginResponse.data.api_key != null) {
              Cookies.set(COOKIE_NAME_FOR_API_KEY, postLoginResponse.data.api_key, {
                expires: COOKIE_EXPIRES_FOR_API_KEY,
              });
              SessionStorageUtils.clear();
              localStorage.removeItem('PsDetails.PsTextCondition.Copy');
              navigate('../home');
            }
          }
        })
        .catch(() => {
          setError('user_id', { type: 'custom', message: `The User ID or password is incorrect.` });
        });
      setIsSubmitting(false);
    })();
  };

  return (
    <div id="loginfr">
      {errorCode != null && <div>{t('エラーが発生しました。')}</div>}
      <div id="loginfr-in">
        <div>
          <img src="/images/cms_logo.png" alt="CMS-POC" />
          {isLogout() && <p className="logouttxt">{t('ログアウトしました')}</p>}
          <form onSubmit={onSubmit}>
            <fieldset disabled={isSubmitting} className="fieldset-reset">
              <input type="text" className="loginip" placeholder={t('ユーザーID') || ''} {...register('user_id')} />

              {errors.user_id?.type === 'required' && <p className="errormessage show">{errors.user_id.message}</p>}
              <input
                type="password"
                className="loginip2"
                placeholder={t('パスワード') || ''}
                {...register('password')}
              />
              {errors.password?.type === 'required' && <p className="errormessage show">{errors.password.message}</p>}
              {errors.user_id && errors.user_id.type === 'custom' && (
                <p className="errormessage show">{errors.user_id.message}</p>
              )}
              <input type="submit" value={t('ログイン') || ''} />
            </fieldset>
          </form>
        </div>
        {isSubmitting && <SpinnerModal />}
      </div>
    </div>
  );
}

export default LoginTestPage;
